export default function NativeAppLayout({
  children,
}: {
  children: JSX.Element;
}): JSX.Element {
  return <>{children}</>;
}
